export default "__VITE_ASSET__Clb26hPm__"